import React from "react";
import {Bookmark, Cpu, GitCommit, Loader, ThumbsUp} from "react-feather";
import {ComponenteFeature} from "../Componentes/indexComponentes";
import {Container} from "../Home/styleHome";
import img_disputa from "../imagens/disputa@2x.png";
import {
    Container1,
    Container1Texto,
    Container2,
    ContainerHeader,
    texto,
    Triangulo
} from "../Componentes/styleComponentes";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ImagemDisputa} from "./styleDisputa";

export const Disputa = ({disputa}) => {
    return (
        <Container id={"disputa"}>
            <ContainerHeader>
                <Container1 background={"#3C3939"}>
                    <ImagemDisputa scroll={disputa}>
                        <img
                            src={img_disputa}
                            height={"auto"}
                            width={"99%"}
                            alt={"disputa"}
                        />
                    </ImagemDisputa>
                    <Container1Texto>
                        <div style={{display: "flex"}}>
                            <div style={{fontSize: "50px", marginRight: "20px"}}>
                                <FontAwesomeIcon icon={"gavel"} color="#8c6851"/>
                            </div>
                            <header>
                <span
                    style={{
                        color: "#b1b1b1"
                    }}
                >
                  MÓDULO
                </span>
                                <h2>DISPUTA</h2>
                            </header>
                        </div>
                        <div>
                            <p>
                                Tenha acesso a estratégias exclusivas que se adaptam em cada modalidade de forma
                                estratégica e com alta performance no envio de lances, dispondo de uma simplicidade
                                incrível na configuração e utilização.
                            </p>
                        </div>
                    </Container1Texto>
                </Container1>
                <Triangulo/>
                <Container2>
                    <ComponenteFeature
                        status={disputa}
                        titulo={"ATUALIZADO"}
                        subTitulo={"SALA DE DISPUTA ADAPTADA AO NOVO DECRETO"}
                        icone={<Loader/>}
                        texto={
                            "Dispute suas licitações com alta performance independente da modalidade aplicada."
                        }
                    />
                    <ComponenteFeature
                        status={disputa}
                        titulo={"INTEGRAÇÃO"}
                        subTitulo={"HISTÓRICO DA DISPUTA"}
                        icone={<GitCommit/>}
                        texto={
                            "Salve todo o relatório de disputa diretamente na plataforma."
                        }
                    />
                    <ComponenteFeature
                        status={disputa}
                        titulo={"ALTA PERFORMANCE"}
                        subTitulo={"LANCES ENVIADOS PRECISAMENTE"}
                        icone={<Cpu/>}
                        texto={
                            "Automatiza o cálculo e o envio de seu lances, aplicando estratégias exclusivas."
                        }
                    />
                    <ComponenteFeature
                        status={disputa}
                        titulo={"SIMPLICIDADE E FACILIDADE"}
                        subTitulo={"TOTALMENTE OBJETIVOS"}
                        icone={<ThumbsUp/>}
                        texto={
                            "Disponibilizamos uma interface totalmente amigável e minimalista, tornando o procedimento facilitado."
                        }
                    />
                </Container2>
            </ContainerHeader>
        </Container>
    );
};
